import { BaseEvent } from "@/api/ws/events/BaseEvent";
import type { CheckoutTemplate } from "@/api/http/schemas/checkoutSchemas";

export type CheckoutSnapshotSavedEvent = Omit<CheckoutTemplate, "name" | "description">;

export default class CheckoutSnapshotWasUpdatedEvent extends BaseEvent<CheckoutSnapshotSavedEvent> {
  name = ".checkout_snapshot_saved";
}
